import { useCallback } from "react";
import { useConfig } from "./useConfig";
import { useBanner } from "./useBanner";

export const useVerifyRedirect = (target: string) => {
  const config = useConfig();
  const { issuerId, brokerId } = useBanner();

  return useCallback(() => {
    let targetWithQueryString = target;
    if (issuerId) {
      targetWithQueryString += `?issuer=${issuerId}`;
    } else if (brokerId) {
      targetWithQueryString += `?broker=${brokerId}`;
    }
    window.location.href = config.VERIFICATION_PORTAL_BASE_URL + '/' + targetWithQueryString;
  }, [brokerId, config, issuerId, target]);
}
